"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const anatomy_1 = require("@chakra-ui/anatomy");
const utils_1 = require("@chakra-ui/utils");
const alertAnatomy = anatomy_1.alertAnatomy.extend('close');
const LIGHT_STATUS_STYLE_MAPPING = {
    info: {
        backgroundColor: 'blue.50',
        borderColor: 'notification.blue',
        titleColor: 'blue.600',
        iconColor: 'notification.blue',
    },
    warning: {
        backgroundColor: 'yellow.50',
        borderColor: 'yellow.400',
        titleColor: 'yellow.700',
        iconColor: 'yellow.500',
    },
    success: { backgroundColor: 'green.50', borderColor: 'green.400', titleColor: 'green.600', iconColor: 'green.400' },
    error: { backgroundColor: 'red.50', borderColor: 'red.400', titleColor: 'red.600', iconColor: 'red.400' },
    loading: {
        backgroundColor: 'blue.50',
        borderColor: 'notification.blue',
        titleColor: 'blue.600',
        iconColor: 'notification.blue',
    },
};
const variantLight = props => {
    const { status = 'info' } = props;
    const { backgroundColor, borderColor, iconColor, titleColor } = LIGHT_STATUS_STYLE_MAPPING[status];
    return (0, utils_1.mergeWith)({}, props.theme.components.Alert.variants.subtle(props), {
        container: {
            backgroundColor,
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor,
        },
        icon: {
            color: iconColor,
        },
        title: {
            color: titleColor,
        },
        description: {
            color: 'gray.800',
        },
        close: {
            _hover: {
                bg: 'blackAlpha.100',
            },
            _active: {
                bg: 'blackAlpha.200',
            },
        },
    });
};
const DARK_BACKGROUND_COLOR_MAPPING = {
    info: 'blue.500',
    warning: 'purple.400',
    success: 'green.600',
    error: 'red.500',
    loading: 'blue.500',
};
const variantDark = props => {
    const { status = 'info' } = props;
    const backgroundColor = DARK_BACKGROUND_COLOR_MAPPING[status];
    return (0, utils_1.mergeWith)({}, props.theme.components.Alert.variants.solid(props), {
        container: {
            backgroundColor,
            color: 'white',
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: backgroundColor,
        },
        close: {
            color: 'white',
            _hover: {
                bg: 'whiteAlpha.100',
            },
            _active: {
                bg: 'whiteAlpha.200',
            },
        },
    });
};
const baseStyle = {
    container: {
        alignItems: 'flex-start',
        borderRadius: 'md',
    },
    title: {
        fontWeight: 'semibold',
        lineHeight: 'base',
    },
    description: {
        lineHeight: 'short',
        fontWeight: 'normal',
    },
    close: {
        bg: 'transparent',
        borderRadius: 'md',
        color: 'gray.800',
    },
};
const sizes = {
    sm: {
        container: {
            padding: 3,
        },
        title: {
            fontSize: 'sm',
        },
        description: {
            fontSize: 'sm',
        },
    },
    lg: {
        container: {
            padding: 4,
        },
        title: {
            fontSize: 'md',
        },
        description: {
            fontSize: 'md',
        },
    },
};
const variants = {
    light: variantLight,
    dark: variantDark,
};
const defaultProps = {
    size: 'sm',
    variant: 'light',
};
const AlertStyles = {
    baseStyle,
    sizes,
    variants,
    defaultProps,
};
exports.default = AlertStyles;
